<script lang="ts">
  import type { WorkOrderAssignmentRow } from "../../../../contract"
  import ContextTags from "../../../../_shared/_modules/context-tags"

  let { row }: { row: WorkOrderAssignmentRow } = $props()
</script>

<div class="requester-contact-data-cell" class:disabled={row.disabled}>
  <ContextTags tags={row.requesterContactMethods} />
</div>

<style lang="less">
  .requester-contact-data-cell {
    max-width: 280px;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .requester-contact-data-cell.disabled {
    opacity: 0.6;
  }
</style>
